import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Typography,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';

import { api } from '../api';
import { formatDateTimeFr } from '../methods';
import { Notification, NotificationStatus } from '../types';

const NotificationDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const [notification, setNotification] = useState<Notification | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api
            .get(`/notifications/${id}`)
            .then((res) => setNotification(res.data))
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (!notification) {
        return (
            <Box textAlign="center" mt={4}>
                <Typography variant="h6" color="error">
                    Notification not found.
                </Typography>
            </Box>
        );
    }

    return (
        <Card sx={{ maxWidth: 800, margin: 'auto', mt: 4, p: 2 }}>
            <CardContent>
                <Typography variant="h5" gutterBottom>
                    Title: {notification.title}
                </Typography>
                <Typography variant="body1" color="text.secondary" gutterBottom>
                    Message: {notification.message}
                </Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    Sent at: {formatDateTimeFr(notification.sent_at)}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="h6" gutterBottom>
                    Device Statuses
                </Typography>

                {notification.statuses.length === 0 ? (
                    <Typography color="text.secondary">No statuses available.</Typography>
                ) : (


                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                        <Table size="small" aria-label="notification statuses">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Device ID</TableCell>
                                      <TableCell>Token</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Sent At</TableCell>
                                      <TableCell>Response</TableCell>
                                    
                                    <TableCell>Platform</TableCell>
                                    <TableCell>Last Registered</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {notification.statuses.map((status: NotificationStatus) => (
                                    <TableRow key={status.id}>
                                        <TableCell>{status.device.id}</TableCell>
                                        <TableCell>{status.device.token}</TableCell>
                                        <TableCell>
                                            <Typography fontWeight="bold" variant="subtitle2">
                                                {status.status}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>{formatDateTimeFr(status.sent_at)}</TableCell>
                                         <TableCell>{status.response}</TableCell>
                                        
                                        
                                        <TableCell>{status.device.platform}</TableCell>
                                        <TableCell>{formatDateTimeFr(status.device.last_registered_at)}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                )}
            </CardContent>
        </Card>
    );
};

export default NotificationDetails;
